import { removeFromClass } from "./data-psm-executor-utils.js";
export function executeDataPsmDeleteContainer(reader, createNewIdentifier, operation) {
    return removeFromClass(reader, operation.dataPsmOwner, operation.dataPsmContainer);
}
//# sourceMappingURL=data-psm-delete-container-executor.js.map